<script lang="ts">
  import type { FetchHealth } from '../lib/types';

  let { health, label }: { health?: FetchHealth; label?: string } = $props();

  const COLOR: Record<FetchHealth, string> = {
    ok: 'var(--ok)',
    degraded: 'var(--tier2)',
    down: 'var(--danger)',
  };
  const TITLE: Record<FetchHealth, string> = {
    ok: 'Bộ thu chạy bình thường',
    degraded: 'Bộ thu chậm hoặc lỗi một phần',
    down: 'Bộ thu đang dừng',
  };

  const color = $derived(health ? COLOR[health] : 'var(--ink-dim)');
  const baseTitle = $derived(health ? TITLE[health] : 'Chưa rõ trạng thái bộ thu');
  const title = $derived(label ? `${label}: ${baseTitle}` : baseTitle);
</script>

<span class="pulse" style="background:{color}" {title} aria-label={title}></span>
